<template>
    <!-- table -->
    <div class="qt-full-table">
  <table>
    <tr>
      <th>Details</th>
      <th v-for="(month, index) in months" :key="index">{{ month }}</th>
    </tr>
    <tr class="qt-red-text">
      <td>Target Hours
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.targetHour || 0).toFixed(2) }}</td>
    </tr>
    <tr>
      <td>Hours Recorded
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.actualHour || 0).toFixed(2) }}</td>
    </tr>
    <tr>
      <td>Billable Hours
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.billableHour || 0).toFixed(2) }}</td>
    </tr>
    <tr>
      <td>Non Billable Hours
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.nonBillableHour || 0).toFixed(2) }}</td>
    </tr>
    <tr class="dashboard-balance">
      <td>Balance
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.balanceHour || 0).toFixed(2) }}</td>
    </tr>
    <tr class="dashboard-release-status">
      <td>Release Status
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index" :class="timerecording.releaseStatus === 'Released' ? 'qt-green-text' : 'qt-orange-text'">{{ timerecording.releaseStatus }}</td>
    </tr>
    <tr>
      <td>Vacation Hours
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.vacationHour || 0).toFixed(2) }}</td>
    </tr>
    <tr>
      <td>Sickness Hours
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.sicknessHour || 0).toFixed(2) }}</td>
    </tr>
    <tr>
      <td>Other Absence Hours
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.otherHour || 0).toFixed(2) }}</td>
    </tr>
    <tr>
      <td>Travel Billable
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.travelBillable || 0).toFixed(2) }}</td>
    </tr>
    <tr>
      <td>Travel Non Billable
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.travelNonBillable || 0).toFixed(2) }}</td>
    </tr>
    <tr>
      <td>Internal Project Hours
      </td>
      <td v-for="(timerecording, index) in timeRecordingOverview" :key="index">{{ (timerecording.internalProjectHours || 0).toFixed(2) }}</td>
    </tr>
  </table>
</div>


  </template>
  
  <script>
  export default {
    data() {
    return {
      months: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec','Total'
      ]
    };
  },
  beforeMount(){
    this.$store.dispatch("TimeRecordingOverview");
  },
  computed: {
		timeRecordingOverview: function () {
			return this.$store.state.qtimeReports.timeRecordingOverview;
		}
  }
  };
  </script>